import animations from './animations.glb'
import handAnims from './handAnimations.glb'
import makerAnims from './makerAnimations.glb'

export default {
    animations,
    handAnims,
    makerAnims,
}
